import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React from 'react'
import cmsBlogPostTableColumns from '../../molecules/table-column/cms-blog-post-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns : PropTypes.arrayOf(PropTypes.string),
  isLoading     : PropTypes.bool
}

const defaultProps = {
  rowButtonProps: {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  },
  isLoading: false
}

/**
 * Table to display List of CMS Blog Posts
 * @param {Array<Object>} data - array of blog_post objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */

const cmsBlogPostTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps

  const columns = cmsBlogPostTableColumns({
    buttonText,
    buttonColour,
    isButtonDisabled,
    onButtonClick
  })

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

cmsBlogPostTable.propTypes    = propTypes
cmsBlogPostTable.defaultProps = defaultProps

export default cmsBlogPostTable
